export default __webpack_public_path__ + "static/media/ASV.dbbf3beb.jfif";